import { RootState } from '@/index';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CLSTAG, IssueStatus, IssueType } from '@/utils/constant';
import CompleteIssueModal from '@/components/CompleteIssueModal';
import classNames from 'classnames';
import { clstagStr, showMsg } from '@/utils/util';
import { HttpStatusCode } from '@/fetch/core/constant';
import IssueApi from '@/fetch/bussiness/issue';
import ReminderModal from '@/components/ReminderModal';
const fetchApi = new IssueApi();
const CompleteIssue = (props: { vehicleName: string; disabled: boolean }) => {
  const { vehicleName, disabled } = props;
  const { issueList } = useSelector((state: RootState) => state.workOrder);
  const [remindReportModal, setRemindReportModal] = useState(false);
  const issueStatus =
    issueList &&
    issueList.find((workOrder: any) => {
      return (
        workOrder.vehicleName === vehicleName &&
        workOrder.issueType === IssueType.OPS
      );
    })?.issueStatus;
  const issueNumber =
    issueList &&
    issueList.find((workOrder: any) => {
      return (
        workOrder.vehicleName === vehicleName &&
        workOrder.issueType === IssueType.OPS
      );
    })?.issueNumber;
  const [open, setOpen] = useState(false);
  const usable = issueStatus === IssueStatus.PROCESS && !disabled;
  const getCurrentIssueEventInfo = async () => {
    try {
      const res = await fetchApi.getIssueEvent({ issueNumber: issueNumber });
      if (res.code === HttpStatusCode.Success) {
        if (res.data.accidentProcessed) {
          setOpen(true);
        } else {
          setOpen(false);
          setRemindReportModal(true);
        }
      } else {
        showMsg({
          msg: res.message,
          type: 'error',
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div
        className={classNames('', {
          'mini-item': usable,
          'mini-item-disabled': !usable,
        })}
        onClick={() => {
          usable && getCurrentIssueEventInfo();
        }}
        clstag={clstagStr(CLSTAG.CompleteIssue)}
      >
        <div
          className={classNames('', {
            'operate-complete': usable,
            'operate-complete-disabled': !usable,
          })}
        />

        <h3 className='operate_key'>结单</h3>
      </div>
      <CompleteIssueModal
        open={open}
        setOpen={setOpen}
        issueNumber={issueNumber}
        vehicleName={vehicleName}
      />
      <ReminderModal
        vehicleName={vehicleName}
        remindReportModal={remindReportModal}
        setRemindReportModal={setRemindReportModal}
      />
    </>
  );
};
export default React.memo(CompleteIssue);
